import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    Typography,
    Select,
    MenuItem,
    InputLabel,
    Box,
    Switch,
    DialogContentText,
    Tooltip,
    Card,
    CardContent,
    Grid
} from '@material-ui/core';
import Draggable from 'react-draggable';
import TreeItem from '@material-ui/lab/TreeItem';
import SettingsIcon from '@material-ui/icons/Settings';
import DeleteIcon from '@material-ui/icons/Delete';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import Notification from '../components/shared/notification.component';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import { HexColorPicker } from 'react-colorful';
import EdgeOrREST from '../EdgeOrREST';
import { useDispatch } from 'react-redux';
import ResultsTable from './gridResultsTable';
import { Slider } from '@mui/material';


export default function GridEditor(props) {
    const [gridSettingOpen, setGridSettingOpen] = React.useState(false);
    const [settingId, setSettingId] = React.useState(0);
    const [settingGridXStart, setSettingGridXStart] = React.useState(0);
    const [settingGridYStart, setSettingGridYStart] = React.useState(0);
    const [settingGridZStart, setSettingGridZStart] = React.useState(0);
    const [settingGridWidth, setSettingGridWidth] = React.useState(0);
    const [settingGridHeight, setSettingGridHeight] = React.useState(0);
    const [settingGridDepth, setSettingGridDepth] = React.useState(0);
    const [gridValueFontSize, setGridValueFontSize] = React.useState(8);
    const [gridName, setGridName] = React.useState("");
    const [color, setColor] = React.useState("#00008B");
    const [selectedStandard, setSelectedStandard] = React.useState('EN13201:2015 Illuminance');
    const [selectedGridClass, setSelectedGridClass] = React.useState('P1');
    const [gridClass, setGridClass] = React.useState(['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'C0', 'C1', 'C2', 'C3', 'C4', 'C5']);
    const [gridVerticalClass, setGridVerticalClass] = React.useState(['EV1', 'EV2', 'EV3', 'EV4', 'EV5']);
    const [gridYSpacing, setGridYSpacing] = React.useState(null);
    const [gridXSpacing, setGridXSpacing] = React.useState(null);
    const [showName, setShowName] = React.useState(false);
    const [showValues, setShowValues] = React.useState(true);
    const [pointYSpacing, setPointYSpacing] = React.useState(null);
    const [pointXSpacing, setPointXSpacing] = React.useState(null);
    const [pointSpacing, setPointSpacing] = React.useState(false);
    const [edgeStart, setEdgeStart] = React.useState(false);
    const [opacity, setOpacity] = React.useState(1);

    // Add grid type state
    const [gridType, setGridType] = React.useState('Horizontal');

    const [lavGreaterThan, setLavGreaterThan] = React.useState(null);
    const [reiGreaterThan, setReiGreaterThan] = React.useState(null);
    const [tiLessThan, setTILessThan] = React.useState(null);
    const [u0GreaterThan, setU0GreaterThan] = React.useState(null);
    const [ulGreaterThan, setULGreaterThan] = React.useState(null);
    const [wetU0GreaterThan, setWetU0GreaterThan] = React.useState(null);
    const [eMinGreaterThan, setEMinGreaterThan] = React.useState(null);
    const [eavGreaterThan, setEavGreaterThan] = React.useState(null);
    const [eavLessThan, setEavLessThan] = React.useState(null);
    const [lMaxLMinRatioLessThan, setLMaxLMinRatioLessThan] = React.useState(null);
    const [lavLMinRatioLessThan, setLavLMinRatioLessThan] = React.useState(null);
    const [lvMaxLavRatioLessThan, setLvMaxLavRatioLessThan] = React.useState(null);
    const [ephGreaterThan, setEphGreaterThan] = React.useState(null);
    const [epvGreaterThan, setEpvGreaterThan] = React.useState(null);
    const [ue2LessThan, setUE2LessThan] = React.useState(null);
    const [esGreaterThan, setEsGreaterThan] = React.useState(null);
    const [ue1LessThan, setUE1LessThan] = React.useState(null);
    const [uwlrLessThan, setUWLRLessThan] = React.useState(null);


    function getResultsTable(grid) {
        if (props.gridResults && props.gridResults[grid.id] && props.gridResults[grid.id].calcResults) {
            return <ResultsTable id={grid.id} name={grid.name} standard={grid.gridStandard} results={props.gridResults[grid.id].calcResults}
                variables={{
                    lavGreaterThan,
                    reiGreaterThan,
                    tiLessThan,
                    u0GreaterThan,
                    ulGreaterThan,
                    wetU0GreaterThan,
                    eMinGreaterThan,
                    eavGreaterThan,
                    eavLessThan,
                    lMaxLMinRatioLessThan,
                    lavLMinRatioLessThan,
                    lvMaxLavRatioLessThan,
                    ephGreaterThan,
                    epvGreaterThan,
                    ue2LessThan,
                    esGreaterThan,
                    ue1LessThan,
                    uwlrLessThan
                }}
            />;
        }
        return null;
    }

    const handleGridSettingClick = (index) => {
        // ...existing code...
        const grid = props.grids[index];
        const isVertical = (grid.type || 'Horizontal') === 'Vertical';
        const yLength = Number(grid.origin?.y?.length ?? 0);
        const zLength = Number(grid.origin?.z?.length ?? 0);
        const effectiveHeight = isVertical ? (zLength || yLength) : yLength;

        setSettingId(index);
        setSettingGridXStart(grid.origin.x.start);
        setSettingGridYStart(grid.origin.y.start);
        setSettingGridZStart(grid.origin?.z?.start ?? 0);
        setSettingGridWidth(grid.origin.x.length);
        setSettingGridHeight(isVertical ? 0 : effectiveHeight);
        setSettingGridDepth(effectiveHeight);
        setGridName(grid.name);
        setColor(grid.color);
        setSelectedGridClass(grid.gridClass);
        setSelectedStandard(grid.gridStandard);
        setGridXSpacing(grid.xSpacing);
        setGridYSpacing(grid.ySpacing);
        setPointXSpacing(Math.floor(Number(grid.origin.x.length) / Number(grid.xSpacing || 1)));
        setPointYSpacing(Math.floor(effectiveHeight / Number(grid.ySpacing || 1)));
        setShowName(grid.visible);
        setShowValues(grid.showValues ?? true);
        setEdgeStart(grid.edgeStart || false);
        setGridValueFontSize(grid.gridValueFontSize || 8);

        setGridType(grid.type || 'Horizontal');
        setGridSettingOpen(true);
    };

    // useEffect(() => {
    //     if (gridSettingOpen && props.grids[settingId]) {
    //         setSettingGridXStart(props.grids[settingId].origin.x.start);
    //         setSettingGridYStart(props.grids[settingId].origin.y.start);
    //         setSettingGridWidth(props.grids[settingId].origin.x.length);
    //         setSettingGridHeight(props.grids[settingId].origin.y.length);
    //         setGridType(props.grids[settingId].type || 'Horizontal');
    //     }
    // }, [props.grids, gridSettingOpen, settingId]);

    const handleGridSettingSave = () => {
        const hasWidth = settingGridWidth > 0;
        const hasHeight = settingGridHeight > 0;
        const hasDepth = settingGridDepth > 0;

        const isValidDimensions =
            gridType === 'Vertical'
                ? hasWidth && hasDepth
                : hasWidth && hasHeight;

        if (isValidDimensions) {
            const tempGrids = JSON.parse(JSON.stringify(props.grids));

            tempGrids[settingId].origin.x.start = settingGridXStart;
            tempGrids[settingId].origin.x.length = settingGridWidth;
            tempGrids[settingId].origin.y.start = settingGridYStart;
            tempGrids[settingId].origin.y.length = settingGridHeight == 0 ? 1 : settingGridHeight;
            tempGrids[settingId].gridValueFontSize = gridValueFontSize;

            let newYSpacing, newXSpacing;

            if (pointSpacing) {
                newXSpacing = pointXSpacing > 1
                    ? props.grids[settingId].origin.x.length / pointXSpacing
                    : props.grids[settingId].origin.x.length;

                newYSpacing = pointYSpacing > 1
                    ? props.grids[settingId].origin.y.length / pointYSpacing
                    : props.grids[settingId].origin.y.length;
            } else {
                newXSpacing = gridXSpacing;
                newYSpacing = gridYSpacing;
            }

            // Save grid type
            tempGrids[settingId].type = gridType;

            if (gridType === 'Vertical') {
                tempGrids[settingId].gridClass = selectedGridClass;
                tempGrids[settingId].origin.z.start = settingGridZStart;
                tempGrids[settingId].origin.z.length = settingGridDepth;
            }

            props.updateGridOnSave(
                settingId,
                gridName,
                color,
                selectedStandard,
                selectedGridClass,
                newXSpacing,
                newYSpacing,
                showName,
                edgeStart,
                showValues,
                opacity,
                tempGrids
            );

            setGridSettingOpen(false);
        } else {
            props.setSnack({
                open: true,
                message: "Please enter valid dimensions (Width and Height must be greater than 0)",
                severity: 'warning'
            });
        }
    };



    const onShowGridResults = (index) => {
        const updatedGrid = { ...props.grids[index] };
        updatedGrid.showResults = !updatedGrid.showResults;
        props.updateGridResults(index, updatedGrid.showResults);
    };


    const onSetSettingGridWidth = (e) => {
        setSettingGridWidth(e.target.value);
    }
    const onSetSettingGridHeight = (e) => {
        setSettingGridHeight(e.target.value);
    }
    const onSetSettingGridXStart = (e) => {
        setSettingGridXStart(e.target.value);
    }
    const onSetSettingGridYStart = (e) => {
        setSettingGridYStart(e.target.value);
    }
    const onSetGridType = (e) => {
        const nextType = e.target.value;
        setGridType(nextType);

        if (nextType === 'Vertical') {
            setSelectedGridClass('EV1');
            const nextDepth = Number(settingGridDepth) > 0 ? Number(settingGridDepth) : Number(settingGridHeight) || 1;
            setSettingGridDepth(nextDepth);
            setSettingGridHeight(0);
        } else {
            setSelectedGridClass('P1');
            const nextHeight = Number(settingGridHeight) > 0 ? Number(settingGridHeight) : Number(settingGridDepth) || 1;
            setSettingGridHeight(nextHeight);
        }
    }

    const dropbox = [
        'EN13201:2015 Illuminance',
        // 'EN13201:2015 Luminance',
        'BS5489:2020 Illuminance',
        // 'IES RP-8-18',
        'CIE140 Illuminance',
        // 'CIE140 Luminance',
        // 'NZS1158:2005 Cat P Illuminance',
        //'NZS1158:2005 Cat V Luminance',
        // 'AUS Illuminance',
        // 'AUS Luminance',
    ]

    useEffect(() => {
        onStandardChange({ target: { value: 'EN13201:2015 Illuminance' } });
    }, []);

    const onStandardChange = (event) => {
        const standardId = event.target.value;
        setSelectedStandard(standardId);
        let illumTypeId = "Luminance";

        if (standardId.includes("Illuminance")) {
            illumTypeId = "Horizontal";
        }

        EdgeOrREST(null, 'SET_ROAD_CONFIG', onGetStandard, {
            postObject: { standardId, illumTypeId },
        });
    };

    const onGetStandard = (response) => {
        setGridClass(response.data.standard.CalcGridClass);
        setSelectedGridClass(response.data.standard.CalcGridClass[0]);

        const defaultStandards = response.data.standard.DefaultStandards;

        if (defaultStandards) {
            setLavGreaterThan(defaultStandards.LavGreaterThan ?? null);
            setReiGreaterThan(defaultStandards.ReiGreaterThan ?? null);
            setTILessThan(defaultStandards.TILessThan ?? null);
            setU0GreaterThan(defaultStandards.U0GreaterThan ?? null);
            setULGreaterThan(defaultStandards.ULGreaterThan ?? null);
            setWetU0GreaterThan(defaultStandards.WetU0GreaterThan ?? null);
            setEMinGreaterThan(defaultStandards.EMinGreaterThan ?? null);
            setEavGreaterThan(defaultStandards.EavGreaterThan ?? null);
            setEavLessThan(defaultStandards.EavLessThan ?? null);
            setLMaxLMinRatioLessThan(defaultStandards.LMaxLMinRatioLessThan ?? null);
            setLavLMinRatioLessThan(defaultStandards.LavLMinRatioLessThan ?? null);
            setLvMaxLavRatioLessThan(defaultStandards.LvMaxLavRatioLessThan ?? null);
            setEphGreaterThan(defaultStandards.EphGreaterThan ?? null);
            setEpvGreaterThan(defaultStandards.EpvGreaterThan ?? null);
            setUE2LessThan(defaultStandards.UE2LessThan ?? null);
            setEsGreaterThan(defaultStandards.EsGreaterThan ?? null);
            setUE1LessThan(defaultStandards.UE1LessThan ?? null);
            setUWLRLessThan(defaultStandards.UWLRLessThan ?? null);
            props.setGridResultsMinimum(defaultStandards.EMinGreaterThan ?? 1);
        }
    };


    const onGridClassChange = (event) => {
        setSelectedGridClass(event.target.value);
        var gridClassId = event.target.value;

        if (selectedStandard.includes("Illuminance")) var illumTypeId = "Horizontal";
        else illumTypeId = "Luminance";

        EdgeOrREST(gridClassId, 'SET_CALC_GRID_CLASS', onGetGridClass, {
            postObject: {
                gridClassId,
                standardId: selectedStandard,
                illumTypeId: illumTypeId
            },
            props: props
        });
    }

    const onGetGridClass = (response) => {
        const defaultStandards = response.data.standard.DefaultStandards;

        if (defaultStandards) {
            setLavGreaterThan(defaultStandards.LavGreaterThan ?? null);
            setReiGreaterThan(defaultStandards.ReiGreaterThan ?? null);
            setTILessThan(defaultStandards.TILessThan ?? null);
            setU0GreaterThan(defaultStandards.U0GreaterThan ?? null);
            setULGreaterThan(defaultStandards.ULGreaterThan ?? null);
            setWetU0GreaterThan(defaultStandards.WetU0GreaterThan ?? null);
            setEMinGreaterThan(defaultStandards.EMinGreaterThan ?? null);
            setEavGreaterThan(defaultStandards.EavGreaterThan ?? null);
            setEavLessThan(defaultStandards.EavLessThan ?? null);
            setLMaxLMinRatioLessThan(defaultStandards.LMaxLMinRatioLessThan ?? null);
            setLavLMinRatioLessThan(defaultStandards.LavLMinRatioLessThan ?? null);
            setLvMaxLavRatioLessThan(defaultStandards.LvMaxLavRatioLessThan ?? null);
            setEphGreaterThan(defaultStandards.EphGreaterThan ?? null);
            setEpvGreaterThan(defaultStandards.EpvGreaterThan ?? null);
            setUE2LessThan(defaultStandards.UE2LessThan ?? null);
            setEsGreaterThan(defaultStandards.EsGreaterThan ?? null);
            setUE1LessThan(defaultStandards.UE1LessThan ?? null);
            setUWLRLessThan(defaultStandards.UWLRLessThan ?? null);
            props.setGridResultsMinimum(defaultStandards.EMinGreaterThan ?? 1);
        }
    }

    const onGridSpacingXChange = (e) => {
        setGridXSpacing(e.target.value);
    };

    const onGridSpacingYChange = (e) => {
        setGridYSpacing(e.target.value);
    };

    const toggleNameVisibility = (e) => {
        setShowName(!showName);
    };

    const toggleValueVisibility = (e) => {
        setShowValues(!showValues);
    };

    const onPointSpacingXChange = (e) => {
        setPointXSpacing(e.target.value);
    };

    const onPointSpacingYChange = (e) => {
        setPointYSpacing(e.target.value);
    };


    const togglePointSpacing = (e) => {
        setPointSpacing(!pointSpacing);
    };

    const toggleEdgeStart = (e) => {
        setEdgeStart(!edgeStart);
    };

    const handleChangeOpacity = (event, newValue) => {
        // console.log("Opacity", newValue);
        setOpacity(newValue);
    };


    return (
        <>

            <Box sx={{ maxHeight: "500px", overflowY: "auto", width: "100%" }}>
                <List style={{ padding: 0 }}>
                    {props.grids.map((grid, index) => (
                        grid.id !== 0 && (
                            <>
                                {/* List Item */}
                                <ListItem key={index} onClick={() => props.selectGrid(grid.id)} style={grid.selected ? { border: "2px solid darkturquoise", padding: '5px' } : { padding: '5px' }}>
                                    <Tooltip title={grid.name} placement="top">
                                        <ListItemText
                                            primary={
                                                <span
                                                    style={{
                                                        display: "inline-block",
                                                        maxWidth: "150px",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        userSelect: "none",
                                                    }}
                                                >
                                                    {grid.name}
                                                </span>
                                            }
                                        />
                                    </Tooltip>

                                    <ListItemSecondaryAction style={{ display: "flex", alignItems: "center" }}>
                                        <IconButton aria-label="setting" style={{ padding: 4 }} onClick={() => handleGridSettingClick(index)}>
                                            <SettingsIcon style={{ fontSize: 24 }} />
                                        </IconButton>
                                        <Tooltip title={grid.showResults ? "Hide Results" : "Show Results"} placement="top">
                                            <IconButton onClick={() => onShowGridResults(index)} style={{ padding: 4 }}>
                                                {grid.showResults
                                                    ? <AnalyticsIcon style={{ fontSize: 24 }} />
                                                    : <AnalyticsOutlinedIcon style={{ fontSize: 24 }} />
                                                }
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title={grid.locked ? "Unlock Grid" : "Lock Grid"} placement="top">
                                            <IconButton onClick={() => props.lockGrid(grid.id)} style={{ padding: 4 }}>
                                                {grid.locked ? <LockIcon style={{ fontSize: 24 }} /> : <LockOpenIcon style={{ fontSize: 24 }} />}
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete Grid" placement="top">
                                            <IconButton aria-label="delete" style={{ padding: 4 }} onClick={() => props.deleteGrid(grid.id)}>
                                                <DeleteIcon style={{ fontSize: 24 }} />
                                            </IconButton>
                                        </Tooltip>
                                    </ListItemSecondaryAction>
                                </ListItem>

                                {/* Results Table - Rendered below the ListItem if `showResults` is true */}
                                {grid.showResults && (
                                    <Box sx={{ paddingLeft: 2, paddingTop: 1, paddingBottom: 1 }}>
                                        {getResultsTable(grid)}
                                    </Box>
                                )}
                            </>
                        )
                    ))}
                </List>
            </Box>



            <Dialog open={gridSettingOpen}>
                <DialogTitle>Edit Grid</DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px" }}>
                        <TextField
                            label="Grid Name"
                            value={gridName}
                            variant="outlined"
                            name="name"
                            onChange={(e) => setGridName(e.target.value)}
                        />

                        <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                            <span>Show Name</span>
                            <Switch
                                onChange={(e) => toggleNameVisibility(e)}
                                checked={showName}
                                name="showName"
                                color="primary"
                            />
                        </label>

                        <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                            <span>Show Values (3D Only)</span>
                            <Switch
                                onChange={(e) => toggleValueVisibility(e)}
                                checked={showValues}
                                name="showValues"
                                color="primary"
                            />
                        </label>
                    </div>


                    <DialogContentText>Set your grid's class and type</DialogContentText>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px' }}>
                        <TextField
                            style={{ margin: '10px' }}
                            label="Grid Class"
                            name="calcGridClass"
                            onChange={(e) => onGridClassChange(e, props)}
                            select
                            SelectProps={{ native: true }}
                            value={selectedGridClass}
                            variant="outlined"
                        >
                            {gridType == "Vertical" ? gridVerticalClass.map((option) => (
                                <option key={option}>{option}</option>
                            )) : gridClass.map((option) => (
                                <option key={option}>{option}</option>
                            ))}
                        </TextField>

                        <TextField
                            style={{ margin: '10px', minWidth: '120px' }}
                            label="Grid Type"
                            name="gridType"
                            onChange={e => onSetGridType(e)}
                            select
                            SelectProps={{ native: true }}
                            value={gridType}
                            variant="outlined"
                        >
                            <option value="Horizontal">Horizontal</option>
                            <option value="Vertical">Vertical</option>
                        </TextField>
                    </div>

                    <DialogContentText>Set your grid spacing</DialogContentText>

                    <div flex="row" style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px" }}>
                        <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                            <span>Edge Start</span>
                            <Switch
                                onChange={(e) => toggleEdgeStart(e)}
                                checked={edgeStart}
                                name="showName"
                                color="primary"
                            />
                        </label>

                        <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                            <span>Point Spacing</span>
                            <Switch
                                onChange={(e) => togglePointSpacing(e)}
                                checked={pointSpacing}
                                name="showName"
                                color="primary"
                            />
                        </label>

                        <div style={{
                            display: 'flex',
                            gap: '8px',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                            <TextField
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                                    setGridValueFontSize(value);
                                }}
                                onFocus={(e) => e.target.select()}
                                onBlur={(e) => {
                                    const val = e.target.value;
                                    e.target.value = '';
                                    e.target.value = val;
                                }}
                                type="text"
                                value={gridValueFontSize}
                                variant="outlined"
                                label="Grid Font Size"
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                    maxLength: 2,
                                    style: { height: '20px', padding: '5px', textAlign: 'center' }
                                }}
                                style={{ width: '100px' }}
                            />
                        </div>
                    </div>

                    <div>
                        {!pointSpacing
                            ?
                            <div>
                                <TextField
                                    onChange={(e) => onGridSpacingXChange(e)}
                                    onBlur={() => setGridXSpacing(prev => prev === "" ? 1.5 : prev)}
                                    style={{ margin: '10px' }}
                                    label={"Grid X Spacing"}
                                    name="gridXSpacing"
                                    type="number"
                                    value={gridXSpacing}
                                    variant="outlined"
                                    inputProps={{
                                        step: 0.25,
                                        min: 1.5
                                    }}
                                />

                                <TextField
                                    onChange={(e) => onGridSpacingYChange(e)}
                                    onBlur={() => setGridYSpacing(prev => prev === "" ? 1.5 : prev)}
                                    style={{ margin: '10px' }}
                                    label={"Grid Y Spacing"}
                                    name="gridYSpacing"
                                    type="number"
                                    value={gridYSpacing}
                                    variant="outlined"
                                    inputProps={{
                                        step: 0.25,
                                        min: 1.5
                                    }}
                                />
                            </div>
                            :
                            <div>
                                <TextField
                                    onChange={(e) => onPointSpacingXChange(e)}
                                    onBlur={() => setPointXSpacing(prev => prev === "" ? 33 : prev)}
                                    style={{ margin: '10px' }}
                                    label={"Number of X Points"}
                                    name="pointXSpacing"
                                    type="number"
                                    value={pointXSpacing}
                                    variant="outlined"
                                    inputProps={{
                                        step: 1,
                                    }}
                                />

                                <TextField
                                    onChange={(e) => onPointSpacingYChange(e)}
                                    onBlur={() => setPointYSpacing(prev => prev === "" ? 33 : prev)}
                                    style={{ margin: '10px' }}
                                    label={"Number of Y Points"}
                                    name="pointYSpacing"
                                    type="number"
                                    value={pointYSpacing}
                                    variant="outlined"
                                    inputProps={{
                                        step: 1,
                                    }}
                                />
                            </div>
                        }
                    </div>

                    <DialogContentText>Set your grid dimensions</DialogContentText>
                    <span>
                        <TextField
                            onChange={onSetSettingGridXStart} style={{ margin: '10px' }} label={"X start"} name="xStart" type="number"
                            value={settingGridXStart} variant="outlined"
                            inputProps={{
                                step: 0.25
                            }}
                        />

                        <TextField onChange={onSetSettingGridYStart} style={{ margin: '10px' }} label={"Y start"} name="yStart" type="number"
                            value={settingGridYStart} variant="outlined"
                            inputProps={{
                                step: 0.25
                            }}
                        />
                        {gridType !== 'Vertical' ? <></> : (
                            <TextField onChange={(e) => setSettingGridZStart(e.target.value)} style={{ margin: '10px' }} label={"Z start"} name="zStart" type="number"
                                value={settingGridZStart} variant="outlined"
                                inputProps={{
                                    step: 0.25
                                }}
                            />
                        )}
                    </span>
                    <span>
                        <TextField onChange={onSetSettingGridWidth} style={{ margin: '10px' }} label={"Width (m)"} name="xLength" type="number"
                            value={settingGridWidth} variant="outlined"
                            inputProps={{
                                step: 0.25
                            }}
                        />
                        {gridType !== 'Vertical' ? (
                            <TextField onChange={onSetSettingGridHeight} style={{ margin: '10px' }} label={"Height (m)"} name="yLength" type="number"
                                value={settingGridHeight} variant="outlined"
                                inputProps={{
                                    step: 0.25
                                }}
                            />
                        ) : (
                            <TextField onChange={(e) => setSettingGridDepth(e.target.value)} style={{ margin: '10px' }} label={"Height (m)"} name="zLength" type="number"
                                value={settingGridDepth} variant="outlined"
                                inputProps={{
                                    step: 0.25
                                }}
                            />
                        )}
                    </span>
                    <TextField
                        label="Opacity"
                        value={opacity}
                        variant="outlined"
                        name="opacity"
                        style={{ margin: "10px", display: "none" }}
                    />
                    <Typography gutterBottom>Opacity</Typography>
                    <Slider
                        value={opacity}
                        onChange={handleChangeOpacity}
                        step={0.1}
                        min={0.1}
                        max={1}
                        marks
                        valueLabelDisplay="auto"
                        sx={{
                            margin: "10px",
                            width: "90%",
                            color: "#1976d2",
                            '& .MuiSlider-thumb': {
                                width: 20,
                                height: 20,
                            },
                            '& .MuiSlider-rail': {
                                height: 8,
                            },
                            '& .MuiSlider-track': {
                                height: 8,
                            },
                        }}
                    />

                    <HexColorPicker color={color} onChange={(e) => setColor(e)} style={{ height: "150px" }} />
                    Selected Color: {color}
                </DialogContent>
                <div style={{ textAlign: "right", margin: 10 }}>
                    <Button onClick={() => handleGridSettingSave()} style={{ margin: '10px' }} color="primary" variant="contained"><Typography>Save</Typography></Button>
                    <Button onClick={() => setGridSettingOpen(false)} color="primary" style={{ margin: '10px' }} variant="contained"><Typography>Cancel</Typography></Button>
                </div>
            </Dialog>
        </>
    );
}
